import { ItemKind, ResearchRecommendations } from '../../models/research.models';

/**
 * The server could not compute `Kind`'s recommendations this load (`ResearchRecommendations.failedKinds`, the same fact Home's
 * "Not refreshed" tile and partial-failure banner show). The list it sent is empty because it did not load, not because nothing
 * matched, so a finder's Recommended tab shows its load-failure panel (ListErrorCopy, "Try again") instead of the empty state.
 */
export class RecommendationsNotRefreshedError extends Error {
    constructor(readonly Kind: ItemKind) {
        super(`${Kind} recommendations could not refresh`);
        this.name = 'RecommendationsNotRefreshedError';
    }
}

/** Throws {@link RecommendationsNotRefreshedError} when the server reported `kind` as failed in `result`. */
export function AssertRecommendationsRefreshed(result: Pick<ResearchRecommendations, 'failedKinds'>, kind: ItemKind): void {
    if (result.failedKinds.includes(kind)) throw new RecommendationsNotRefreshedError(kind);
}
